import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { DollarSign, UserCheck } from "react-feather";
import { formatNumberWithCommas } from "../../../../utils/utility";

export default function TransactionsList({ transaction = [], onAssignSalesperson }) {
    return (
        <Table striped bordered hover responsive>
            <thead className="table-light">
                <tr
                    style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                    }}
                >
                    <th>S.No</th>
                    <th>Actions</th>
                    <th>Transaction ID</th>
                    <th>Payment Date</th>
                    <th>Amount</th>
                    <th>Remaining Amount</th>
                    <th>Company</th>
                    <th>Sales Person</th>
                    <th>Status</th>
                    <th>Remarks</th>
                </tr>
            </thead>
            <tbody>
                {transaction.length === 0 ? (
                    <tr>
                        <td colSpan={9} className="text-center">
                            No data available
                        </td>
                    </tr>
                ) : (
                    transaction.map((data, index) => (
                        <tr key={data.id ?? index}>
                            <td>{index + 1}</td>
                            <td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Invoice Payment</Tooltip>}
                                >
                                    <a
                                        href={`/tms/bank-transactions/payment/${data.id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="me-1"
                                    >
                                        <DollarSign size={18} color="#6c757d" />
                                    </a>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Assign Sales Person</Tooltip>}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 me-1"
                                        onClick={() => onAssignSalesperson(data)}
                                    >
                                        <UserCheck size={18} color="#6c757d" />
                                    </button>
                                </OverlayTrigger>
                            </td>
                            <td>{data.reference_number || "-"}</td>
                            <td>{data.date || "-"}</td>
                            <td>${formatNumberWithCommas(data.amount ?? 0)}</td>
                            <td>${formatNumberWithCommas(data.remaining_amount ?? 0)}</td>
                            <td>{data.company?.name || "-"}</td>
                            <td>{data.salesperson?.name || "-"}</td>
                            <td>{data.status || "-"}</td>
                            <td>{data.remarks || "-"}</td>
                        </tr>
                    ))
                )}
            </tbody>
        </Table>
    );
}
